import React, { Component } from 'react';
import ptBR from 'antd/es/locale/pt_BR';
import moment from 'moment';
import 'moment/locale/pt-br';
import { connect } from 'react-redux';
import { Empty, ConfigProvider } from 'antd';
import { AuthContextProvider } from 'react-structure-admin';
import getDataFromStorage from 'util/getDataFromStorage';
import { Routes } from 'components/routes';
import config from './config';

import {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  THEME_TYPE_DARK
} from './constants/themeSettings';
import 'assets/vendors/style';
import 'styles/wieldy.less';

moment.locale('pt-br');
moment.updateLocale('pt-br', {
  weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
});

const customizeRenderEmpty = () => (
  <Empty
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    description="Nenhum registro para exibir"
  />
);

class Main extends Component {
  componentDidMount() {
    window.addEventListener('focus', this.onFocus);
  }

  onFocus = () => {
    const { refreshToken } = this.props;
    const { expirationDate } = getDataFromStorage('auth_data');

    if (expirationDate) {
      const expiration = moment(expirationDate);
      const base = moment();

      if (expiration.isBefore(base)) {
        window.location.reload();
      }
    }

    const currentRefreshToken = localStorage.getItem('auth_refreshtoken');
    if (currentRefreshToken && refreshToken !== currentRefreshToken) {
      window.location.reload();
    }
  };

  handleBeforeRefreshToken = (authData) => {
    return {
      refreshToken: authData.refreshToken,
      type: 'professional'
    };
  };

  setLayoutType = (layoutType) => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('full-layout');
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove('full-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('boxed-layout');
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('full-layout');
      document.body.classList.add('framed-layout');
    }
  };

  setNavStyle = (navStyle) => {
    if (
      navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
      navStyle === NAV_STYLE_DARK_HORIZONTAL ||
      navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
      navStyle === NAV_STYLE_ABOVE_HEADER ||
      navStyle === NAV_STYLE_BELOW_HEADER
    ) {
      document.body.classList.add('full-scroll');
      document.body.classList.add('horizontal-layout');
    } else {
      document.body.classList.remove('full-scroll');
      document.body.classList.remove('horizontal-layout');
    }
  };

  componentWilUnmount() {
    window.removeEventListener('focus', this.onFocus);
  }

  render() {
    const { themeType, layoutType, navStyle } = this.props;

    if (themeType === THEME_TYPE_DARK) {
      document.body.classList.add('dark-theme');
    }

    this.setLayoutType(layoutType);
    this.setNavStyle(navStyle);

    return (
      <ConfigProvider renderEmpty={customizeRenderEmpty} locale={ptBR}>
        <AuthContextProvider
          enableRefreshToken
          onBeforeRefreshToken={this.handleBeforeRefreshToken}
        >
          <Routes routes={config.routes} isContainer={config.isContainer} />
        </AuthContextProvider>
      </ConfigProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { themeType, layoutType, navStyle } = settings;
  const { refreshToken } = auth;
  return { themeType, layoutType, navStyle, refreshToken };
};

export default connect(mapStateToProps, null)(Main);
